import { render } from "./Cs2Page.vue?vue&type=template&id=d092d588&scoped=true"
import script from "./Cs2Page.vue?vue&type=script&lang=js"
export * from "./Cs2Page.vue?vue&type=script&lang=js"

import "./Cs2Page.vue?vue&type=style&index=0&id=d092d588&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d092d588"]])

export default __exports__